module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/babel-loader/lib/index.js??ref--4!../../node_modules/webpack-strip/lib/index.js?strip[]=console.log,strip[]=console.error,strip[]=console.info!./en-CA.js"));
	}, "locale_en-CA");
}